/* src/components/DigitalOutreach.js */
import React from "react";
import './DigitalOutreach.css'
import '../components/ProductsHeroBanner';
import ProductHeroBanner from "../components/ProductsHeroBanner";
import Navbar from '../components/Navbar'
//import Solutions from "../components/Solutions";
//import digitalOutreachSolutionsData from "../components/digitalOutreachSolutionsData";
import Footer from "../components/Footer";
import ContentBlocks from "../components/ContentBlocks";
import CallToAction from "../components/CallToAction";
import { Helmet } from "react-helmet";

const DigitalOutreach = () => {

    const pageData = {
        heading: "Digital Outreach Features",
        blocks: [
            {
                blockHeading: "Reputation Management",
                text: "Sustainable practice growth hinges on reputation. With Doclivo, manage surveys, respond to reviews, and build trust - all from a single dashboard. Attract and retain patients effortlessly."
            },
            {
                blockHeading: "Practice Marketing & Advertising",
                text: "Expand your patient volume and online audience through digital ads and engaging social content that connects with patients beyond appointments. Collaborate with our healthcare advertising and social media experts to craft original content and promote your practice effectively."
            },
           
        ]
    };

    return (
        <>
            <Helmet>
                <title> DigitalOutreach - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
            <Navbar></Navbar>
            <section className="digital-outreach-section">
                <div className="digital-outreach-container">
                    <h5 className="digital-outreach-subheading">Boost Your Online Presence with Digital Outreach</h5>
                    <h1 className="digital-outreach-main-heading">Reach your audience effectively and build meaningful connections with our digital outreach solutions.</h1>
                    <h2 className="digital-outreach-heading-text"> From social media engagement to targeted advertising to reputation management, we've got you covered</h2>
                </div>

                <ProductHeroBanner></ProductHeroBanner>

                <ContentBlocks
                    heading={pageData.heading}
                    subheading={pageData.subheading}
                    blocks={pageData.blocks}
                />
                <CallToAction></CallToAction>
            </section>
            <Footer></Footer>
        </>
    );
};

export default DigitalOutreach;